import {Component, Input} from '@angular/core';
import {Platform} from "@angular/cdk/platform";
import { catchError, from, map, of } from 'rxjs';
import { MessagesService } from '@core/_services/messages.service';
import { DownloadService } from '@service/download.service';

@Component({
  selector: 'atf-view',
  templateUrl: './atf-view.component.html',
  styleUrl: './atf-view.component.scss'
})
export class AtfViewComponent {
  @Input() public docId: string
  @Input() public atfName: string
  @Input() public stylePdf: string = 'position: relative;'
  
  public display = false;
  public showPdf = false;
  public pathPdf;

  constructor(
    protected platform: Platform,
    protected _messageService: MessagesService,
    private downloadService: DownloadService
  ) {
  }

  public ngOnInit() {
    let wUrl: any;
    if (this.docId) {
      this.display = false;
      this.showPdf = false;
      this.pathPdf = '';
      return from(this.Show_File()).pipe(
        map(result => {
            if (this.downloadService.getStatus() === false) {
            return;
          }
          wUrl = this.downloadService.getUrl();

          this.display = true;
          this.pathPdf = wUrl;
          this.showPdf = true;            
         }),
        catchError((error: any) => {
            console.log(error);
            return of(null);
        }
      )).subscribe();
    }
  }

  public async Show_File() {
    this.downloadService.setDocId(this.docId);
    if (this.atfName !== '') {
      await this.downloadService.getAtfFile(this.atfName);      
    } else {
      await this.downloadService.downloadDocument('getdocumentcopy', null, true);
    } 
  }
}
